import './Spotlight.scss';

import chaseImage from '../../assets/images/spotlight/chase.webp';
import spotlightBurst from '../../assets/images/spotlight/spotlightbkgd.webp';
import {handleDownloadClick} from '../../utils/gotostore.js';

export default function Spotlight({appleUrl, androidUrl}) {

    return (
        <section className="spotlight">
            <div className="spotlight__image-box">
                <img className="spotlight__image-bg" src={spotlightBurst} alt="Background starburst" />
                <img className="spotlight__image-fg" loading="lazy" src={chaseImage} alt="Chase from Paw Patrol Academy" />
            </div>
            <div className="spotlight__content">
                <h3 className="spotlight__subtitle">Featured Activity:</h3>
                <h2 className="spotlight__title">Heroic Missions</h2>
                <p className="spotlight__copy">Now's your child's chance to lead the PAW Patrol
                 on real missions inside Adventure Bay. 
                 Develop your child's self-confidence daily. No job's too 
                 big. No pup's too small, when your child is in charge of
                 completing the mission</p>
                 <button className="download-button" onClick={() => handleDownloadClick("spotlight", appleUrl, androidUrl)}>Try It Now</button>
            </div>
        </section>
    )
}